(function(e, t, n, r) {
    var i, s, o = !1;
    if (!(i = e.jQuery) || n > i.fn.jquery || r(i, o)) {
        var u = t.createElement("script");
        u.type = "text/javascript", u.src = "https://ajax.googleapis.com/ajax/libs/jquery/1.8.2/jquery.min.js", u.onload = u.onreadystatechange = function() {
            !o && (!(s = this.readyState) || s == "loaded" || s == "complete") && (r((i = e.jQuery).noConflict(1), o = !0), i(u).remove())
        };
        try {
            t.body.appendChild(u)
        } catch (a) {
            try {
                t.documentElement.childNodes[0].appendChild(u)
            } catch (a) {}
        }
    }
})(window, document, "1.8.2", function(e, t) {
    var n = function(t) {
        return t = t.replace(/\//g, " "), t = t.replace(/&/g, " "), t = t.replace(/;/g, " "), t = t.replace(/,/g, " "), t = t.replace(/\./g, "-"), t = t.replace(/\*/g, "-"), t = t.replace(/[^-a-zA-Z0-9,_,&\s]+/ig, ""), t = t.replace(/ +(?= )/g, ""), t = e.trim(t), t = t.replace(/\s/gi, "-"), t = t.replace(/-+/g, "-"), t = t.replace(/-+$/, ""), t.toLowerCase()
    }, r = function(t, n) {
            t.keyup(function() {
                var t = e(this);
                t.val().length > n && t.val(t.val().substr(0, n))
            })
        };
    if (typeof product_customizer != "undefined") {
        var i = e("form[action='/cart/add']"),
            s = {};
        e.each(product_customizer, function(t, o) {
            s[t] = e.parseJSON(o), s[t].name = t;
            var u = e("#customizer_" + n(t));
            s[t]["required"] == "1" && (u.attr("required", "required"), i.submit(function() {
                if (u.val() == "") return u.css("border-color", "red"), !1
            }));
            if (s[t]["type"] == "select") {
                var a = s[t].options.split(",");
                for (option in a) typeof a[option] == "string" && u.append('<option value="' + a[option].replace('"', "&quot;") + '">' + a[option] + "</option>");
                if (typeof window.$ != "undefined") try {
                    window.$("#" + u.attr("id")).trigger("change")
                } catch (f) {}
            } else if (s[t]["type"] == "text" || s[t]["type"] == "multiline") s[t]["char_count"] != "undefined" && (char_count = parseInt(s[t].char_count), r(u, char_count));
            else if (s[t]["type"] == "file") {
                i.attr("enctype", "multipart/form-data");
                var l = i.attr("id");
                typeof l == "undefined" && (l = "no_ajax_form"), i.attr("id", l), typeof window.$ != "undefined" && (i.attr("id", l), window.$("#" + l).unbind("submit"), window.$("#" + l).find("input[type='submit']").unbind("click"), i.find('input[type="submit"]').removeAttr("onclick"))
            }
        })
    }
    var o = function(e, t) {
        return !e || !t ? !1 : e.indexOf(t, e.length - t.length) !== -1
    };
    window.remove_item = function(e) {
        var t = "/cart/change?line=" + e + "&quantity=0";
        window.location.replace(t)
    };
    if (o(e("link[rel=canonical]").attr("href"), "/cart") || window.location.pathname == "/cart") {
        var u = 0;
        e('a[href*="/cart/change"]').each(function(t) {
            e(this).parent().hasClass("update_or_remove") || (e(this).attr("href", "/cart/change?line=" + (u + 1) + "&quantity=0"), u += 1), e(this).removeAttr("onclick")
        }), e("a[href=#][onclick*=remove]").each(function(t) {
            e(this).attr("href", "/cart/change?line=" + (t + 1) + "&quantity=0"), e(this).removeAttr("onclick")
        }), e("[onclick*=remove]").each(function(t) {
            e(this).attr("onclick", "remove_item(" + (t + 1) + ")")
        }), e("input[name*=updates]").each(function() {
            e(this).attr("name", "updates[]")
        })
    }
});